// extracted by mini-css-extract-plugin
export default {"notifications":"styles_notifications__G659n","empty":"styles_empty__huFYd"};